import { combineReducers } from 'redux';

import {
  getUserPermissionsListRequest,
  getUserPermissionsListSuccess,
  getUserPermissionsListFail,
  setUserPermissionsListDirty,
  clearUserPermissionsListByUser,
} from '../actions';
import { UserPermissionsAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { ItemList } from '../../../../types/main';
import { UserPermissions } from '../../../../types/items';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<UserPermissions>>;
type ReducerOf<T extends keyof State> = Reducer<State, UserPermissionsAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getUserPermissionsListRequest.type:
      return state ? stripItems(state) : null;

    case getUserPermissionsListSuccess.type:
      return action.payload;

    case clearUserPermissionsListByUser.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getUserPermissionsListRequest.type:
      return true;

    case getUserPermissionsListSuccess.type:
    case getUserPermissionsListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setUserPermissionsListDirty.type:
      return action.payload;

    case getUserPermissionsListSuccess.type:
    case getUserPermissionsListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  dirty,
});
